// Запуск внутри Telegram. Скрипт Telegram — единственный сторонний скрипт, и грузится он
// только в Mini App: на сайте браузер к telegram.org не обращается.
import type { TelegramWebApp } from "./telegramTypes";

export const TELEGRAM_SCRIPT_URL = "https://telegram.org/js/telegram-web-app.js?64";

// Telegram передаёт данные запуска в адресе после #: tgWebAppData, tgWebAppPlatform…
const TELEGRAM_LAUNCH_PATTERN = /tgWebApp(Data|Platform|Version)=/;

export function isTelegramLaunch(hash: string = window.location.hash): boolean {
  return TELEGRAM_LAUNCH_PATTERN.test(hash);
}

export function getTelegramWebApp(): TelegramWebApp | null {
  const webApp = window.Telegram?.WebApp;
  if (webApp === undefined || webApp.initData === "") {
    return null;
  }
  return webApp;
}

function loadScript(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = url;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Не загрузился скрипт Telegram"));
    document.head.appendChild(script);
  });
}

// Подготовка до отрисовки приложения. В сборке для разработки ?tg=mock подменяет Telegram,
// чтобы посмотреть вёрстку Mini App в обычном браузере; в рабочую сборку подмена не попадает.
export async function prepareTelegram(): Promise<TelegramWebApp | null> {
  if (import.meta.env.DEV && new URLSearchParams(window.location.search).get("tg") === "mock") {
    const { installTelegramMock } = await import("./devMock");
    installTelegramMock();
  }
  if (window.Telegram?.WebApp === undefined && isTelegramLaunch()) {
    await loadScript(TELEGRAM_SCRIPT_URL);
  }
  const webApp = getTelegramWebApp();
  if (webApp !== null) {
    webApp.ready();
    webApp.expand();
  }
  return webApp;
}

// Тема Mini App: светлая или тёмная — из Telegram; фон и текст Telegram подставляет сам
// в переменные --tg-theme-*, токены дизайн-системы читают их (styles/tokens.css).
export function applyTelegramTheme(webApp: TelegramWebApp): () => void {
  const root = document.documentElement;
  const apply = () => {
    root.dataset.channel = "telegram";
    root.dataset.theme = webApp.colorScheme;
    // Фон страницы — secondary_bg_color (tokens.css): заголовок и фон Telegram — в тон.
    webApp.setHeaderColor?.("secondary_bg_color");
    webApp.setBackgroundColor?.("secondary_bg_color");
  };
  apply();
  webApp.onEvent("themeChanged", apply);
  return () => webApp.offEvent("themeChanged", apply);
}

